import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { LegalPolicyConsentItem } from './types';
import { LegalPolicyModal } from './LegalPolicyModal';

interface LegalPolicyConsentFieldProps {
  policies: LegalPolicyConsentItem[];
  acceptedIds: Set<string>;
  onToggle: (policyId: string, accepted: boolean) => void;
  disabled?: boolean;
  layout?: 'default' | 'contratovista';
  /** Sin contenedor de lista; el padre agrupa varios ítems de aceptación */
  unified?: boolean;
}

export function LegalPolicyConsentField({
  policies,
  acceptedIds,
  onToggle,
  disabled = false,
  layout = 'default',
  unified = false,
}: LegalPolicyConsentFieldProps) {
  const [modalSlug, setModalSlug] = useState<string | null>(null);
  const [modalTitle, setModalTitle] = useState<string | undefined>();

  if (policies.length === 0) return null;

  const checkboxClass =
    layout === 'contratovista' ? 'lms-contract-signing-checkbox' : 'lms-legal-policy-consent-checkbox';

  const policyItems = policies.map((policy) => (
    <div key={policy.id} className="lms-legal-policy-consent-item">
      <label className={checkboxClass}>
        <span className="lms-contract-signing-checkbox__box">
          <input
            type="checkbox"
            checked={acceptedIds.has(policy.id)}
            onChange={(e) => onToggle(policy.id, e.target.checked)}
            disabled={disabled}
          />
          <span className="material-symbols-outlined lms-contract-signing-checkbox__icon" aria-hidden="true">
            check
          </span>
        </span>
        <span className="lms-contract-signing-checkbox__label">
          {policy.consentLabel}
          {' '}
          <button
            type="button"
            className="lms-legal-policy-consent-link"
            onClick={(e) => {
              e.preventDefault();
              setModalSlug(policy.slug);
              setModalTitle(policy.title);
            }}
          >
            {policy.linkLabel}
          </button>
          {layout !== 'contratovista' ? (
            <>
              {' · '}
              <Link
                to={`/legal/${policy.slug}`}
                className="lms-legal-policy-consent-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir en página
              </Link>
            </>
          ) : null}
        </span>
      </label>
    </div>
  ));

  return (
    <>
      {unified ? policyItems : (
        <div className="lms-legal-policy-consent-list">{policyItems}</div>
      )}

      {modalSlug ? (
        <LegalPolicyModal
          open={Boolean(modalSlug)}
          slug={modalSlug}
          title={modalTitle}
          onClose={() => {
            setModalSlug(null);
            setModalTitle(undefined);
          }}
        />
      ) : null}
    </>
  );
}
